import { Accordion } from '@/components/AccordionSideMenu';
import { CtaLink } from '@/components/NewHeader/CtaLink';
import {
  BackButton,
  BigContent,
  Item,
  PromotionalSideOffers,
  SmallContent,
} from '@/components/NewHeader/SideMenu/helperComponents';
import { useTranslation } from '@/contexts/dictionaryContext';
import useGTMEvents from '@/hooks/useGTMEvents';
import { usePromotionalCatalogs } from '@/hooks/usePromotionalCatalogs';
import { useState } from 'react';

export function VillasInSicily() {
  const {
    newHeader: { villasInSicily, nav },
  } = useTranslation();
  const { sicily } = usePromotionalCatalogs();
  const [value, setValue] = useState(villasInSicily.byDestination.title);

  const { sendMenuClickEvent } = useGTMEvents();

  const section =
    nav.find((item) => item.id === 'villas-in-sicily')?.title ||
    'Villas in Sicily';
  const offersTitle =
    nav.find((item) => item.id === 'offers')?.title || 'Offers';

  const handleItemClick = (item: { title: string; href: string }) =>
    sendMenuClickEvent({ section, sectionItem: item.title });

  return (
    <>
      <BackButton />

      <Accordion
        type="single"
        collapsible
        className="w-full bg-black/5"
        value={value}
        onValueChange={setValue}>
        <Item
          value={villasInSicily.byDestination.title}
          isOpen={value === villasInSicily.byDestination.title}>
          <BigContent
            onItemClick={handleItemClick}
            items={villasInSicily.byDestination.items}
          />
        </Item>

        <Item
          value={villasInSicily.byType.title}
          isOpen={value === villasInSicily.byType.title}>
          <SmallContent
            onItemClick={handleItemClick}
            items={villasInSicily.byType.items}
          />
        </Item>

        <Item
          value={villasInSicily.byArea.title}
          isOpen={value === villasInSicily.byArea.title}>
          <SmallContent
            onItemClick={handleItemClick}
            items={villasInSicily.byArea.items}
          />
        </Item>
      </Accordion>

      <PromotionalSideOffers
        title={offersTitle}
        items={sicily}
        onItemClick={handleItemClick}
      />

      <div className="p-4">
        <CtaLink
          onClick={() =>
            sendMenuClickEvent({
              section,
              sectionItem: villasInSicily.cta.title,
            })
          }
          href={villasInSicily.cta.href}>
          {villasInSicily.cta.title}
        </CtaLink>
      </div>
    </>
  );
}
